import React, { useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import LoadingScreen from "../../Admin/Loading_Screen/LoadingScreen";
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import Cookies from "js-cookie";
import close from "../../../../src/Assets/close icon.svg";
import hourglas from "../../../../src/Assets/hourglass 1.svg";


const ThreeMonthsExtension = ({ product, onClose }) => {
  const [isClaimed, setIsClaimed] = useState(false);
  const [claimStatus, setClaimStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
const token = Cookies.get("token");
  useEffect(() => {
    const checkWarrantyClaim = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/warranty/check-warranty/${product.productID}`  ,
          { headers: { "Content-Type": "application/json" ,
            "Authorization": token ? `Bearer ${token}` : "",
          } }
        );
        const { exists, status } = response.data;

        if (exists) {
          setIsClaimed(true);
          setClaimStatus(status);
        }
      } catch (error) {
        console.error("Error checking warranty claim:", error);
      } finally {
        setLoading(false);
      }
    };

    checkWarrantyClaim();
  }, [product.productID]);

  const handleClaimWarranty = async () => {
    setIsLoading(true);
    const token = Cookies.get("token");
    let email = "";

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        email = decodedToken.email;
      } catch (error) {
        console.error("Error decoding token:", error);
        alert("Failed to decode token.");
        return;
      }
    } else {
      alert("No token found.");
      return;
    }

    const warrantyData = {
      productName: product.productName,
      serialNo: product.serialNo,
      modelNo: product.modelNo,
      purchaseDate: product.purchaseDate,
      expiryDate: product.expiryDate,
      customerId: product.customerId,
      productID: product.productID,
      warrantyPeriod: product.warrantyPeriod,
      email,
      invoice: product.invoice,
    };

    try {
      await axios.post(`${API_BASE_URL}/api/warranty`, warrantyData  ,
        { headers: { "Content-Type": "application/json" ,
          "Authorization": token ? `Bearer ${token}` : "",
        } });

      setIsClaimed(true);
      setClaimStatus("Claimed");
      setShowSuccessModal(true); // Show the success modal after successful claim
    } catch (error) {
      console.error("Error claiming warranty:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);  // Close the success modal
    onClose();  // Close the main modal
  };

  return (
    <div>
      {isLoading && <LoadingScreen />}
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50"
        onClick={onClose}
      >
        <div
          className="bg-white p-8 rounded-[30px] shadow-xl w-[380px] md:w-[425px] relative"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header Section */}
          <div className="flex items-center justify-between mb-8">
            <h3 className="text-[20px] font-bold text-center text-gray-800 w-full">
              Add 3 Months Warranty
            </h3>
            <button
              onClick={onClose}
              className="absolute top-1 right-2"
            >
              <img
                src={close} // Replace with your image path
                alt="Close"
                className="h-14 w-14 object-contain"
              />
            </button>
          </div>

          {/* Product Details with Text Colors */}
          <div className="grid grid-cols-1 gap-4 mb-8 text-gray-700">
            {[{ label: "Product Name", value: product.productName },
            { label: "Product ID", value: product.productID },
            { label: "Customer ID", value: product.customerId },
            { label: "Model No.", value: product.modelNo },
            { label: "Serial No.", value: product.serialNo },
            { label: "Purchase Date", value: new Date(product.purchaseDate).toLocaleDateString() },
            { label: "Expiry Date", value: new Date(product.expiryDate).toLocaleDateString() },
            { label: "Warranty Period", value: `${product.warrantyPeriod} Year` },
            ].map((item, index) => (
              <div key={index} className="flex justify-between">
                <strong className="text-[#292D32] text-[14px] font-medium">{item.label}</strong>
                <span className="text-[#3159A6] text-[14px]  font-semibold ">{item.value}</span>
              </div>
            ))}
          </div>

          {/* Conditional Section */}
          {loading ? (
            <p className="text-center text-gray-600">Checking warranty status...</p>
          ) : isClaimed ? (
            <p className="text-center text-green-600 font-semibold">"This warranty has already been claimed."</p>
          ) : (
            <div className="text-center mt-6">
              <button
                onClick={handleClaimWarranty}
                className="bg-[#1C50A3] text-white font-semibold px-8 py-2 rounded-lg shadow-[0px_4px_20px_0px_#1C50A380] hover:scale-105 transform transition-transform duration-300 ease-in-out"
              >
                Claim Warranty
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={closeSuccessModal}
        >
          <div
            className="bg-white p-8 rounded-lg shadow-lg w-[340px] md:w-[400px] h-[400px] relative" // Increased height to 400px
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center">
              {/* Icon */}
              <img
                src={hourglas} // Replace with your icon path
                alt="Success Icon"
                className="mx-auto mb-6"
                style={{ width: '120px', height: '120px' }}
              />
              <p className="text-2xl font-semibold text-green-600 mb-4">
                Warranty Claimed
              </p>
              <p className="text-md text-gray-700 font-medium mb-6">
                We’re reviewing your claim. Please wait for confirmation. You’ll get the updated invoice by email after verification.
              </p>
            </div>

            {/* OK Button */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
              <button
                className="px-6 py-2 bg-green-600 text-white font-semibold rounded-lg shadow-lg hover:bg-green-700 transition duration-200 focus:outline-none"
                onClick={closeSuccessModal}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}



    </div>
  );
};

export default ThreeMonthsExtension;
